import { BaseDto } from '@/shared/dtos/base-dto';

export class qr_scans extends BaseDto {
    public qr_id !: number;
    public name !: string;
    public email !: string;
    public verification_token !: string;
    public verified_at!:Date;
    public ip !: string;
    public user_agent !: string;
    public device_info !: string;
    public country !: string;
    public region !: string;
    public city !: string;
    public lat !: number;
    public lng !: number;
    public isp !: string;
    public created_at!:Date;

 } 
